import { FC } from 'react';

import { graphql, useFragment } from 'react-relay';

import { ColumnDefinition, EdColumnCell, EdRow } from 'shared-ui';

import { IdentityAccountRow_account$key } from './__generated__/IdentityAccountRow_account.graphql';

const fragmentDef = graphql`
  fragment IdentityAccountRow_account on IdentityAccountModel {
    identityId
    accountId
    type
    email
    firstName
    lastName
    description
  }
`;

export const identityAccountColumns: Array<ColumnDefinition> = [
  { id: 'types', name: 'Type' },
  { id: 'firstName', name: 'First Name' },
  { id: 'lastName', name: 'Last Name' },
  { id: 'email', name: 'Email' },
  { id: 'description', name: 'Description' },
];

type Props = {
  fragmentRef: IdentityAccountRow_account$key;
};
export const IdentityAccountRow: FC<Props> = ({ fragmentRef }) => {
  const data = useFragment<IdentityAccountRow_account$key>(
    fragmentDef,
    fragmentRef,
  );

  return (
    <EdRow rowKey={data.accountId}>
      <EdColumnCell>{data.type}</EdColumnCell>
      <EdColumnCell>{data.firstName}</EdColumnCell>
      <EdColumnCell>{data.lastName}</EdColumnCell>
      <EdColumnCell>{data.email}</EdColumnCell>
      <EdColumnCell>{data.description}</EdColumnCell>
    </EdRow>
  );
};
